import React, { PropsWithChildren } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CircularProgress } from '@mui/material';

interface ILoadingIndicatorProps {
  loading: boolean;
  error?: boolean;
  size?: number;
  className?: string;
}

const intLoadingIndicatorDefaultSize = 24;

const useStyles = makeStyles<ILoadingIndicatorProps>()((_theme, props) => ({
  wrapper: {
    border: props.error ? '2px solid red' : 'none',
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -((props.size || intLoadingIndicatorDefaultSize) / 2),
    marginLeft: -((props.size || intLoadingIndicatorDefaultSize) / 2),
  },
}));

export function LoadingIndicator(props: PropsWithChildren<ILoadingIndicatorProps>) {
  const { loading, children, className, size = intLoadingIndicatorDefaultSize } = props;
  const { classes } = useStyles({ size, ...props });

  return (
    <div className={`${classes.wrapper} ${className || ''}`}>
      {children}
      {loading && <CircularProgress size={size} className={classes.progress} />}
    </div>
  );
}
